import * as _ from "lodash-es";

export function isEqualForKeys<TA, TB>(a: TA, b: TB, keys: (keyof TA & keyof TB)[]) {
	for (const key of keys) {
		if (!_.isEqual(a[key], b[key])) return false;
	}

	return true;
}

export function isEqual<T extends Record<string, any>>(a: T, b: T): boolean {
	for (const key in a) {
		if (!_.isEqual(a[key], b[key])) return false;
	}

	return true;
}
